import { EntityService } from './EntityService';
import { IEntity, IApp03SprintEvidence } from '../types';

export class App03SprintEvidencesService extends EntityService<IApp03SprintEvidence> {
    public readonly parentEntities = [];
    protected childrenEntities = [];

    constructor() {
        super(`/App03SprintEvidences`);
    }

    public readAllForEvList(sprintID: number): Promise<IEntity[]> {
        return this.readAll(`?getGeneralEvidencesForList=&sprintID=${sprintID}`);
    }
}